export const AVAILABLE_EMOJI = ['👍', '😂', '😥', '😠', '💯', '🔥'];
export const CHAT_PAGE_SIZE = 30;
